import React from 'react';
import type {Component} from '@packages/systems/wfdl';

/**
 * Hook that initializes base site modules when components are loaded
 */
export const useBaseSiteModules = (
  components: Component.ComponentMap | undefined
) => {
  const areBaseSiteModulesInitialized = React.useRef<boolean>(false);

  React.useEffect(() => {
    // TODO: (for Olena) change this to rely more on the full needed data has arrived, so we initialize modules only after
    // we got project rendered. Currently all data does arrive at once, so checking for one part of it is ok, but it might not be the case in the future
    if (components && !areBaseSiteModulesInitialized.current) {
      // we dispatch in a setTimeout to ensure that React has reconciled and the
      // new DOM state makes it to jQuery widgets before dispatching this event.
      setTimeout(() => {
        // needed to initialize BaseSiteModules that are part of the js/site/webflow.js
        window?.dispatchEvent(new Event('__wf_preview'));
        areBaseSiteModulesInitialized.current = true;
      });
    }
  }, [components]);
};
